<template>
    <common-modal :heading="$t('modals.create_company_modal.title')">
        <common-page-plain>
            <common-content-wrapper width="medium">
                <common-content-spacer :isCenter="true" height="medium">
                    <common-company-avatar :withBorder="true" size="medium"></common-company-avatar>

                    <create-company-form @success="emitEvent({ name: 'success' })"></create-company-form>
                </common-content-spacer>
            </common-content-wrapper>
        </common-page-plain>
    </common-modal>
</template>

<script>
    import CreateCompanyForm from 'components/forms/company/CreateCompanyForm'

    export default {
        components: { CreateCompanyForm },
    }
</script>
